export const FoxitStorage = {
  "Ok": "OK",
  "Cancel": "Cancel",
  "Yes": "Yes",
  "No": "No",
  "Subscribe": "Subscribe",
  "Upgrade": "Upgrade plan",
  "Get": "Got it",
  "AddFolderDialog": {
    "Title": "New Folder",
    "EnterFolderName": "Enter folder name:"
  },
  "MoveDialog": {
    "Title": "Move",
    "MoveTo": "Move this item to...",
    "AddFolder": "Add Folder"
  },
  "DuplicateFileDialog": {
    "Title": "Duplicate File Name",
    "NameAlreadyExists": "A file with this name already exists in this location. What would you like to do?",
    "Replace": "Replace the existing file",
    "Rename": "Rename the new file",
    "OkText": "Continue"
  },
  "RenameDialog": {
    "Title": "Rename",
    "EnterNewName": "Enter new name:",
    "OkText": "Save"
  },
  "AutoSave": {
    "Saving": "Saving...",
    "SavedAt": "Saved at"
  },
  "Documents": {
    "Title": "Cloud Documents"
  },
  "Recent": {
    "Title": "Recent"
  },
  "Starred": {
    "Title": "Starred"
  },
  "Table": {
    "DeleteText": "Delete",
    "UnshareText": "Unshare",
    "ClearAll": "Your recent files will no longer be listed here but will appear in your Cloud Documents. Do you want to clear the Recent list?",
    "SureToDeleteSelected": "Are you sure you want to delete the selected items?",
    "SureToDelete": "Are you sure you want to delete {filename}?",
    "SureToDeleteNotUndone": "The selected files will be permanently deleted and this action can't be undone. Are you sure you want to delete the selected items?",
    "SureToDeleteShareFile": "You and the people you shared this file with won't be able to access it once it has been deleted. The file will be permanently deleted and this action can't be undone.",
    "SureToDeleteShareFiles": "The selected files have been shared. If you delete these files, both you and recipients will no longer be able to access them.",
    "UnshareTip": "This file will no longer be accessible to others.",
    "Menu": {
      "AddStarred": "Add to starred",
      "CopySharedLink": "Copy Shared Link",
      "Unshare": "Unshare File",
      "RemoveMe": "Remove Me",
      "EditPDF": "Edit PDF",
      "RequestSignatures": "Request Signatures",
      "AddComments": "Comments PDF",
      "Organize": "Organize pages",
      "Convert": "Convert to PDF",
      "Combine": "Combine Files",
      "Compress": "Compress PDF",
      "Protect": "Protect a PDF",
      "Share": "Share",
      "ShareWithOthers": "Share with others",
      "Rename": "Rename",
      "Move": "Move",
      "Download": "Download",
      "Delete": "Delete",
      "AddFolder": "Add Folder",
      "UploadFiles": "Upload Files",
      "ClearList": "Clear List"
    },
    "Empty": {
      "Documents": {
        "Title": "No documents yet",
        "Desc": "Cloud Documents that you upload from any device will appear here."
      },
      "Recent": {
        "Title": "No recent documents",
        "Desc": "All the documents which have been opened recently will be displayed here."
      },
      "Starred": {
        "Title": "No starred documents",
        "Desc": "Star your important files to quickly find them later."
      },
      "Unlogin": {
        "Title": "Sign in to access Foxit PDF Editor",
        "Signin": "Sign In"
      }
    },
    "Offline": "Cannot connect to the network, please try again later.",
    "Td": {
      "Name": "Name",
      "Status": "Status",
      "LastOpened": "Last Opened",
      "LastModified": "Last Modified",
      "Size": "Size"
    },
    "Shared": "Shared",
    "OnlyYou": "Only you",
    "SendFileToOthers": "Send a file to others for commenting or reviewing",
    "CopySharedLink": "Copy shared link",
    "AddStar": "Add to starred",
    "RemoveStar": "Remove from starred"
  },
  "UploadFiles": {
    "Title": "Upload List",
    "Uploading": "Uploading",
    "UploadFailed": "Upload failed"
  },
  "Error": {
    "DuplicateName": "Cannot create document with duplicate name",
    "DuplicateFolderName": "Cannot create folder with duplicate name: {folderName}",
    "SelectFirst": "Please select a target first!",
    "OverMaxSizeStored": "You currently have over { maxSize } of files stored with Foxit. If you downgrade to a Freemium plan, your files will remain on our servers for 30 days. Thereafter, files from the oldest will be deleted until only { maxSize } remains.",
    "DocumentOverMaxSizeStored": "Your storage space in PDF Editor cloud is reduced to { maxSize }. With Foxit, you have over { maxSize } of files. Files will remain on our servers for 30 days.Thereafter, files from the oldest will be deleted until only { maxSize } remains. It is recommended that you back up the document before it is automatically deleted. Alternatively, you can also manually delete the files that exceed { maxSize } to keep them all.",
    "OutOfStorage": "You're running low on cloud storage space. Please delete some files to free up space.",
    "OutOfStorageUpgrade": "You're running low on cloud storage space. Please delete some files to free up space or consider upgrading for 20GB storage space.",
    "OutOfStorageUpgradeWithoutUpgrad": "You're running low on cloud storage space. Please delete some files to free up space.",
    "FailedAutoSaveOutOfStorage": "Failed to save the document automatically. You're running low on cloud storage space. Please delete some files to free up space.",
    "FailedAutoSaveOutOfStorageUpgrade": "Failed to save the document automatically. You're running low on cloud storage space. Please delete some files to free up space or consider upgrading for 20GB storage space.",
    "NameIncludeSpecialCharacters": "The file name cannot be empty and contain special characters: /:*?\"<>|",
    "UploadFileOutSize": "Upload failed. The maximum allowed file size is 1GB.",
    "CannotMoveWithDuplicateName": "The same file name already exists in this directory.",
    "StopShare": "This file has been unshared or deleted. Contact the owner for more information.",
    "EnterpriseUserOutOfStorage": "You do not have access to Foxit PDF Editor Cloud and your files will remain on our servers for 30 days. Thereafter, all files will be deleted."
  },
  "PasswordProtect": {
    "ApplyToFoxitStorage": "Security settings will be applied to the document when we automatically save the document.You will be able to continue to change security settings until you close the document."
  },
  "DisableStorage": {
    "Table": {
      "Title": "Your organization administrator has disabled the function of Cloud Documents.",
      "Desc": "If you have any questions, please contact your administrator."
    },
    "SharedAlert": "Your organization administrator has disabled the function. If you have any questions, please contact your administrator.",
    "SharedTip": "Your organization administrator has disabled the function of Cloud Documents, so you cannot collaborate with others in PDF Editor Cloud. However, the documents that you use PDF Editor Cloud for collaboration in third-party applications will still be displayed. If you have any questions, please contact your administrator."
  }
}